<script setup>
import { ref } from 'vue'
import { Link, Head, usePage } from '@inertiajs/vue3'
import axios from 'axios'

const show = ref(true);
const props = defineProps({ loginRequest: Object });

function accept() {
    //do axios call to accept login
    axios.post('/portal/login/'+props.loginRequest.id + '/accept')
        .then(response => {
            show.value = false;
        })
}

function decline() {
    axios.post('/portal/login/'+props.loginRequest.id + '/decline')
        .then(response => {
            show.value = false;
        })
}

const page = usePage();
const user = page.props.auth.user;

//connect to the socket, when the login request id is received, hide the notification
window.Echo.private('user.' + user.id)
    .listen('.App\\Events\\LoginAccepted', (e) => {
        if(e.loginRequest.user_id == props.notification.user_id) {
            show.value = false;
        }
    })
    .listen('.App\\Events\\LoginDeclined', (e) => {
        if(e.loginRequest.user_id == props.notification.user_id) {
            show.value = false;
        }
    });
</script>

<template>
    <transition enter-active-class="transform ease-out duration-300 transition" enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2" enter-to-class="translate-y-0 opacity-100 sm:translate-x-0" leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
        <div v-if="show" class="pointer-events-auto flex w-full max-w-md divide-x divide-gray-200 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
            <div class="flex w-0 flex-1 items-center p-4">
                <div class="w-full">
                <p class="text-sm font-medium text-gray-900">Login aanvraag</p>
                <p class="mt-1 text-sm text-gray-500">Verkoper {{loginRequest.user.full_name}} probeert in te loggen.</p>
                </div>
            </div>
            <div class="flex">
                <div class="flex flex-col divide-y divide-gray-200">
                <div class="flex h-0 flex-1">
                    <button type="button" @click="accept" class="flex bg-brightorange text-white w-full items-center justify-center rounded-none rounded-tr-lg border border-transparent px-4 py-3 text-sm font-medium hover:bg-brightorange/80 focus:z-10 focus:outline-none focus:ring-2 focus:ring-indigo-500">Accepteren</button>
                </div>
                <div class="flex h-0 flex-1">
                    <button type="button" @click="decline" class="flex w-full items-center justify-center rounded-none rounded-br-lg border border-transparent px-4 py-3 text-sm font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500">Afwijzen</button>
                </div>
                </div>
            </div>
        </div>
    </transition>
</template>